import './pagination.less'

import React, { Component } from 'react'


class PaginatorItem extends Component {
    clickPage = () => {
        const page = (this.props.item.nextPage)
            ? this.props.item.nextPage
            : this.props.item.page

        this.props.clickPage(page)
    }

    render() {
        const className = `pagination-item${this.props.item.active ? ' active' : ''}`

        return (
            <li className={className} onClick={ this.clickPage }>
                <div>{ this.props.item.page }</div>
            </li>
        )
    }
}


export default PaginatorItem


// WEBPACK FOOTER //
// ./src/components/search/FormElements/paginatorItem/PaginatorItem.js